import React from "react";
import {Button, Link, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import {primaryButtonSx} from "../Onboarding/registrationShared";

export const StatePanel = styled("section")(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const Heading = styled(Typography)(() => ({
  color: "#000000",
  fontSize: "30px",
  fontWeight: 700,
  letterSpacing: "-0.02em",
  lineHeight: 1.25,
}));

export const BodyText = styled(Typography)(() => ({
  color: "#8692A6",
  fontSize: "15px",
  lineHeight: 1.55,
  overflowWrap: "anywhere",
}));

export const EmailAddress = styled(Typography)(() => ({
  color: "#171717",
  fontWeight: 700,
  overflowWrap: "anywhere",
  wordBreak: "break-word",
}));

export const FormStack = styled("form")(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const AccessibleFieldLabel = styled("label")(() => ({
  display: "block",
  width: "100%",
}));

export const VisuallyHidden = styled("span")(() => ({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: 1,
}));

// Designer CTA (primaryButtonSx) minus its top margin; FormStack spaces the form.
export const PrimaryButton = (props) => <Button disableElevation {...props} sx={{...primaryButtonSx, mt: 0, ...props.sx}} />;

/** 48px bordered icon tile above the heading (designer "Check your email" / "Create your password"). */
export const IconTile = styled("div")(() => ({
  alignItems: "center",
  backgroundColor: "rgba(74, 44, 245, 0.04)",
  border: "1.5px solid rgba(74, 44, 245, 0.35)",
  borderRadius: "12px",
  color: "#4A2CF5",
  display: "flex",
  height: 48,
  justifyContent: "center",
  marginBottom: 12,
  width: 48,
}));

export const ActionLink = styled(Link)(() => ({
  alignSelf: "flex-start",
  fontWeight: 600,
}));

export const FeedbackText = styled(Typography)(({theme}) => ({
  color: theme.palette.text.secondary,
  fontSize: "14px",
}));

export const ValidationText = styled(Typography)(({theme}) => ({
  color: theme.palette.error.main,
  fontSize: "14px",
  fontWeight: 600,
}));
